import { ChangeEvent, SyntheticEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAddSavedWord } from "services/dictionary";
import Dialog from "components/ui/Dialog";
import Button from "components/ui/Button";
import Input from "components/formElements/Input/Input";
import "./SaveWords.css";

type AddNewWordDialogProps = {
  open: boolean;
  onClose: () => void;
};

export const AddNewWordDialog = ({ open, onClose }: AddNewWordDialogProps) => {
  const { t } = useTranslation();
  const [word, setWord] = useState("");
  const [notes, setNotes] = useState("");
  const addWord = useAddSavedWord();

  const handleChangeWord = (e: ChangeEvent<HTMLInputElement>) => {
    setWord(e.target.value);
  };

  const handleChangeNote = (e: ChangeEvent<HTMLInputElement>) => {
    setNotes(e.target.value);
  };

  const handleSubmit = (event: SyntheticEvent) => {
    event.preventDefault();
    addWord.mutate({ word, notes }, { onSuccess: onClose });
  };

  return (
    <Dialog
      size="sm"
      className="admin-form-dialog add-word"
      open={open}
      onClose={onClose}
      closeOnOverlayClick={false}
      title={t("Dictionary.addWordDialog.title")}
      secondaryAction={
        <Button size="small" variant="secondary" className="cancel" onClick={onClose}>
          {t("Common.actions.cancel")}
        </Button>
      }
      mainAction={
        <Button size="small" variant="primary" className="submit" onClick={handleSubmit}>
          {t("Dictionary.addWordDialog.submit")}
        </Button>
      }
    >
      <div className="form-fields">
        <div className="width-100">
          <label htmlFor="word">{t("Dictionary.addWordDialog.wordLabel")}</label>
        </div>
        <div className="width-100">
          <Input type="text" value={word} onChange={handleChangeWord} required={true} />
        </div>

        <div className="width-100">
          <label htmlFor="note">{t("Dictionary.addWordDialog.addNotes")}</label>
        </div>
        <div className="width-100">
          <Input type="text" value={notes} onChange={handleChangeNote} required={false} />
        </div>
      </div>
    </Dialog>
  );
};
